import { render, staticRenderFns } from "./userSession.vue?vue&type=template&id=538d4db6&scoped=true"
import script from "./userSession.vue?vue&type=script&lang=js"
export * from "./userSession.vue?vue&type=script&lang=js"
import style0 from "./userSession.vue?vue&type=style&index=0&id=538d4db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538d4db6",
  null
  
)

export default component.exports